import {combineReducers, Reducer} from 'redux'
import { ImagesState } from '@models/image'
import {ImagesActionTypes} from '@actions/image';




// Type-safe initialState!
export const initialState: ImagesState = {
    allIds:[],
    byId:{},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) =>{
    switch(action.type){
        case ImagesActionTypes.FETCH_SUCCESS:{
            const{ data} = action.payload;
            return {
                ...data.reduce( (obj, image) => {
                    obj[image.id] = {
                        ...image,
                        is_fetched: false,
                        ...(state[image.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case ImagesActionTypes.CREATE_SUCCESS:{
            const image = action.payload;
            return {
                ...state,
                [image.id] : image
            };
        }

        case ImagesActionTypes.UPDATE_SUCCESS:{
            const image = action.payload;
            return {
                ...state,
                [image.id] : {
                    ...state[image.id],
                    ...image
                }
            };
        }

        case ImagesActionTypes.FETCH_ITEM_SUCCESS:{
            const image = action.payload;
            return {
                ...state,
                [image.id] : {
                    ...state[image.id],
                    ...image,
                    is_fetched: true
                },
            };
        }

        case ImagesActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case ImagesActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map( item  => item.id);
        }

        case ImagesActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case ImagesActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case ImagesActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case ImagesActionTypes.DELETE_SUCCESS:
            return state - 1;

        case ImagesActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case ImagesActionTypes.FETCH_REQUEST: {
            return true;
        }

        case ImagesActionTypes.FETCH_SUCCESS:
        case ImagesActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<ImagesState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export { reducer as imageReducer }




//Selectors
export const getImagesList = images => images.allIds.map( id => images.byId[id]);
export const getImageById = (images, id) => images.byId[id];